import { styled } from "@mui/system";

export const Container = styled("div")({
  display: "flex",
  backgroundColor: "#fff",
  alignItems: "center",
  padding: "38px 40px",
  borderRadius: "7px",
  marginBottom: "18px",
});